import { formatPersonName } from '@gb-ticket/shared-types';

import { cn } from '@/lib/utils';
import { UserAvatar } from '@/platform/components/user-avatar';
import { useVoice } from '@/platform/voice/use-voice';

/** Name plus avatar. Initials when `profilePhotoUrl` is missing. */
export function PersonChip({
  displayName,
  firstName = '',
  lastName = '',
  profilePhotoUrl,
  className,
  avatarClassName,
}: {
  displayName: string;
  firstName?: string;
  lastName?: string;
  profilePhotoUrl?: string | null;
  className?: string;
  avatarClassName?: string;
}) {
  const voice = useVoice();
  const label = formatPersonName({ firstName, lastName, displayName }, voice);
  return (
    <span className={cn('inline-flex min-w-0 items-center gap-2', className)}>
      <span className={cn('inline-flex size-7 shrink-0', avatarClassName)}>
        <UserAvatar
          firstName={firstName}
          lastName={lastName}
          displayName={label}
          profilePhotoUrl={profilePhotoUrl}
          className="text-[0.65rem]"
        />
      </span>
      <span className="truncate">{label}</span>
    </span>
  );
}
